import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CertificateService} from '../certificate.service';
import {Certificate} from '../models/certificate';
import {StateService} from '../state.service';
import {User} from '../models/User';
import {CertificateStatus} from '../models/certificate-status.enum';
import {AppService} from '../app.service';

@Component({
  selector: 'app-view-certificate',
  templateUrl: './view-certificate.component.html',
  styleUrls: ['./view-certificate.component.scss']
})
export class ViewCertificateComponent implements OnInit {

  public certificate: Certificate;

  public swalApprove = {
    title: 'Approve certificate',
    text: 'Are you sure you want to approve this certificate?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, approve it!',
    showCloseButton: true,
    customClass: {confirmButton: 'btn btn-lg btn-warning', cancelButton: 'btn btn-lg btn-default'}
  };

  public swalReject = {
    title: 'Reject certificate',
    text: 'Are you sure you want to reject this certificate?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, reject it!',
    showCloseButton: true,
    customClass: {confirmButton: 'btn btn-lg btn-warning', cancelButton: 'btn btn-lg btn-default'}
  };

  constructor(private route: ActivatedRoute, private certificateService: CertificateService, private router: Router, private stateService: StateService, private appService: AppService) {
    this.appService.pageTitle = 'Otentica - Certificate';
    this.certificate = certificateService.getById(route.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
  }

  certificatePreview(): { [key: string]: string } {
    if (!this.certificate.thumbnail) {
      return {};
    }
    return {
      'background': `url(/assets/${this.certificate.thumbnail})`
    };
  }

  download(): void {
    window.open(`/assets/${this.certificate.filename}`);
    // window.location.href = `/assets/${this.certificate.filename}`;
  }

  currentUser(): User {
    return this.stateService.getCurrentUser();
  }

  public approve(certificate: Certificate): void {
    certificate.status = CertificateStatus.APPROVED;
  }

  public reject(certificate: Certificate): void {
    certificate.status = CertificateStatus.REJECTED;
  }

}
